export const VIDALINK_FEATURES = [
  'desconto_medicamentos_vidalink_20%',
  'desconto_medicamentos_vidalink_30%',
];
